<mat-card class="rounded-3xl border border-slate-200 p-6 shadow-sm">
  <h2 class="mb-1 text-lg font-semibold text-slate-900">Intervention goals</h2>
  <p class="mb-4 text-sm text-slate-500">
    The specific objectives the provider has to address, for EAP counselling only. The assessment cannot be locked without at least one. The close-out report
    records what was achieved against each.
  </p>

  @if (goals().length === 0 && !canEdit()) {
    <p class="text-sm text-slate-500">No goals have been set.</p>
  }

  <form (submit)="$event.preventDefault(); save()" class="grid gap-2">
    @for (goal of goals(); track goal; let i = $index) {
      <div class="flex items-start gap-2" [formGroup]="goal">
        <mat-form-field appearance="outline" class="flex-1">
          <mat-label>Goal {{ i + 1 }}</mat-label>
          <input matInput maxlength="500" formControlName="text" [readonly]="!canEdit()" />
        </mat-form-field>
        @if (canEdit()) {
          <button mat-icon-button type="button" class="mt-2" aria-label="Remove goal" (click)="remove(i)">
            <mat-icon>delete</mat-icon>
          </button>
        }
      </div>
    }

    @if (canEdit()) {
      <div class="flex flex-wrap items-center justify-between gap-2">
        @if (goals().length < maxGoals) {
          <button mat-stroked-button type="button" (click)="add()">Add a goal</button>
        } @else {
          <span class="text-sm text-slate-500">The most goals a case can have is {{ maxGoals }}.</span>
        }
        <button mat-flat-button type="submit" [disabled]="!canSave()">
          @if (store.savingReferralSummary()) {
            <mat-spinner diameter="20" class="mr-2" />
          }
          Save goals
        </button>
      </div>
    }
  </form>
</mat-card>
